import styled from "styled-components/macro";

export const Error = styled.div`
  color: #eb547c;
  margin-top: 3px;
  font-size: 14px;
`;
